import { render, staticRenderFns } from "./CourseShowPackage.vue?vue&type=template&id=2137ef72&scoped=true"
import script from "./CourseShowPackage.vue?vue&type=script&lang=js"
export * from "./CourseShowPackage.vue?vue&type=script&lang=js"
import style0 from "./CourseShowPackage.vue?vue&type=style&index=0&id=2137ef72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137ef72",
  null
  
)

export default component.exports